var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3383 10.6416L11.0093 18.8906L2.68024 10.6416C2.13086 10.107 1.69813 9.4644 1.40928 8.75435C1.12044 8.0443 0.981741 7.28213 1.00193 6.51584C1.02211 5.74955 1.20074 4.99574 1.52656 4.30188C1.85239 3.60802 2.31835 2.98914 2.89511 2.4842C3.47187 1.97927 4.14693 1.59923 4.87778 1.36801C5.60863 1.13678 6.37944 1.05939 7.14167 1.1407C7.9039 1.22201 8.64104 1.46026 9.30666 1.84046C9.97229 2.22065 10.552 2.73454 11.0093 3.34978C11.4685 2.73901 12.0489 2.2296 12.714 1.85345C13.3792 1.47729 14.1149 1.24248 14.875 1.16371C15.635 1.08494 16.4032 1.16391 17.1314 1.39567C17.8596 1.62743 18.5321 2.007 19.1068 2.51062C19.6815 3.01423 20.1461 3.63106 20.4715 4.32249C20.7969 5.01392 20.976 5.76506 20.9978 6.52892C21.0195 7.29277 20.8833 8.05289 20.5978 8.7617C20.3122 9.4705 19.8834 10.1127 19.3383 10.6482",
    stroke: "url(#paint0_linear_842_1804)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0092 3.34302L7.35225 7.00001C7.14406 7.20827 7.0271 7.49069 7.0271 7.78516C7.0271 8.07963 7.14406 8.36205 7.35225 8.57031L7.95527 9.17333C8.72154 9.9396 9.96534 9.9396 10.7316 9.17333L11.8421 8.06279C12.1701 7.7344 12.5596 7.47388 12.9884 7.29613C13.4171 7.11838 13.8767 7.02688 14.3409 7.02688C14.805 7.02688 15.2646 7.11838 15.6933 7.29613C16.1221 7.47388 16.5116 7.7344 16.8396 8.06279L19.3383 10.5615M11.5645 13.8931L13.7856 16.1142M14.3409 11.1168L16.5619 13.3378",
    stroke: "url(#paint1_linear_842_1804)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_842_1804",
    x1: 0.637133,
    y1: 10.373,
    x2: 21.326,
    y2: 10.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6430E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895EF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_842_1804",
    x1: 6.80373,
    y1: 9.99651,
    x2: 19.5389,
    y2: 9.99651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6430E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895EF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagementIcon);
export default __webpack_public_path__ + "static/media/engagement-icon.87b0f418232edfabaeaefa7e2e2f9c78.svg";
export { ForwardRef as ReactComponent };